import { render } from "./grid.vue?vue&type=template&id=0f5c53ce"
import script from "./grid.vue?vue&type=script&lang=js"
export * from "./grid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/shared/list/grid/grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f5c53ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f5c53ce', __exports__)) {
    console.log('reload')
    api.reload('0f5c53ce', __exports__)
  }
  
  module.hot.accept("./grid.vue?vue&type=template&id=0f5c53ce", () => {
    console.log('re-render')
    api.rerender('0f5c53ce', render)
  })

}


export default __exports__